// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { ServerResponse } from "http";

export const reroute = (res?: ServerResponse, slug?: string | string[] | ParsedUrlQuery): void => {
    if (Array.isArray(slug)) {
        res?.redirect(308, `/${slug.slice(0, -1).join("/")}`);
    }

    res?.redirect(308, `/`);
};
